import React from 'react';
import { Grid, IconButton, Box, Typography } from '@mui/material';
import MentionEditor from '../../TextEditor/MentionEditor';
import ExclamationIcon from '../../Component/Icons/ExclamationIcon';
import useAPIResReqStore from '../useAPIResReqStore';
import CloseIcon from '@mui/icons-material/Close';

const deleteHeaders = (headerId, sampleHeaderId, validateRequest) => {
  useAPIResReqStore.getState().requestData.headers = useAPIResReqStore.getState().requestData.headers.filter(
    h => h.header_id !== headerId
  );
  useAPIResReqStore.getState().sampleData.headers = useAPIResReqStore.getState().sampleData.headers.filter(
    h => h.header_id !== sampleHeaderId
  );
  validateRequest();
};

const CustomHeader = ({
  headers,
  headerErrors,
  availablePlaceholders,
  onFocus,
  keyPlaceholders,
  valuePlaceholders,
  validateRequest,
}) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={5.5}>
          <Typography variant="body2">Key</Typography>
        </Grid>
        <Grid item xs={5.5}>
          <Typography variant="body2" align="left">
            Value
          </Typography>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>

      {headers.map((header, index) => (
        <Grid container spacing={2} sx={{ mb: 2 }} key={header.header_id} alignItems="center">
          <Grid item xs={5.5}>
            <MentionEditor
              text={header.header_name}
              availablePlaceholders={availablePlaceholders}
              placeholders={keyPlaceholders[index]}
              placeholder="Key"
              variant="outlined"
              className="mention-editor-black"
              onChange={value => {
                useAPIResReqStore.getState().requestData.headers[index].header_name = value;
                useAPIResReqStore.getState().sampleData.headers[index].header_name = value;
              }}
              error={header.header_name.trim() === '' && headerErrors ? true : false}
              InputProps={{
                endAdornment: header.header_name.trim() === '' && headerErrors && (
                  <ExclamationIcon />
                ),
              }}
              onFocus={() => {
                onFocus({
                  headerType: 'key',
                  index,
                  step: 'request',
                });
              }}
              helperText={
                header.header_name.trim() === '' && headerErrors ? 'Key cannot be empty' : null
              }
            />
          </Grid>
          <Grid item xs={5.5}>
            <MentionEditor
              text={header.header_value}
              availablePlaceholders={availablePlaceholders}
              placeholders={valuePlaceholders[index]}
              placeholder="Value"
              variant="outlined"
              className="mention-editor-black"
              onChange={value => {
                useAPIResReqStore.getState().requestData.headers[index].header_value = value;
                useAPIResReqStore.getState().sampleData.headers[index].header_value = value;
                validateRequest();
              }}
              error={header.header_value.trim() === '' && headerErrors ? true : false}
              InputProps={{
                endAdornment: header.header_value.trim() === '' && headerErrors && (
                  <ExclamationIcon />
                ),
              }}
              onFocus={() => {
                onFocus({
                  headerType: 'value',
                  index,
                  step: 'request',
                });
              }}
              helperText={
                header.header_value.trim() === '' && headerErrors ? 'Value cannot be empty' : null
              }
            />
          </Grid>
          <Grid item xs={1} sx={{ display: 'flex', justifyContent: 'center' }}>
            <IconButton
              size="small"
              onClick={() => {
                deleteHeaders(
                  header.header_id,
                  useAPIResReqStore.getState().sampleData.headers.length > 0
                    ? useAPIResReqStore.getState().sampleData.headers[index].header_id
                    : '',
                  validateRequest
                );
              }}
              aria-label="delete header"
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </Box>
  );
};

export default CustomHeader;
